import { Box, FormField, FormHelp, Heading, Input, Label } from '@zillow/constellation-10';
import { useFormContext } from 'react-hook-form';

const maxLengthValidation = { value: 32, message: 'Name must be under 32 characters' };

export function LegalNameStep() {
  const {
    formState: { errors },
    register,
  } = useFormContext();

  return (
    <>
      <Heading level={2} textStyle="heading-sm" css={{ marginBottom: 'default', fontFamily: 'heading-alt' }}>
        What is your legal name?
      </Heading>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
        <FormField
          label={<Label>First name</Label>}
          control={
            <Input
              maxLength={maxLengthValidation.value}
              {...register('firstName', {
                required: 'First name is required',
              })}
            />
          }
          description={errors.firstName && <FormHelp>{String(errors.firstName.message)}</FormHelp>}
          error={!!errors.firstName}
        />
        <FormField
          label={<Label>Middle name</Label>}
          control={<Input maxLength={maxLengthValidation.value} {...register('middleName')} />}
          description={
            errors.middleName ? (
              <FormHelp>{String(errors.middleName.message)}</FormHelp>
            ) : (
              <FormHelp>Leave blank if you don’t have a middle name</FormHelp>
            )
          }
          optional
          error={!!errors.middleName}
        />
        <FormField
          label={<Label>Last name</Label>}
          control={
            <Input
              maxLength={maxLengthValidation.value}
              {...register('lastName', { required: 'Last name is required' })}
            />
          }
          description={errors.lastName && <FormHelp>{String(errors.lastName.message)}</FormHelp>}
          error={!!errors.lastName}
        />
      </Box>
    </>
  );
}
